import { render, staticRenderFns } from "./table_config_basicinfo_add.vue?vue&type=template&id=c38c5f00"
import script from "./table_config_basicinfo_add.vue?vue&type=script&lang=js"
export * from "./table_config_basicinfo_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c38c5f00')) {
      api.createRecord('c38c5f00', component.options)
    } else {
      api.reload('c38c5f00', component.options)
    }
    module.hot.accept("./table_config_basicinfo_add.vue?vue&type=template&id=c38c5f00", function () {
      api.rerender('c38c5f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/metadata/table_config_basicinfo_add.vue"
export default component.exports